import cn from "classnames";
import TruncatedString from "components/shared/truncatedString";
import { syncEntityStatuses, syncEntityStatusesEnum } from "helpers/enums";
import Tooltip from "rc-tooltip";
import React from "react";

const truncateStringConfig = {
    truncateLength: 200,
    showedLength: 300,
};

const BitSyncStatusInfo = ({ bid, organizationTimezone }) => {
    const { syncStatusData } = bid;
    if (!syncStatusData) {
        return null;
    }
    const { fixedAt, syncStatus, comment } = syncStatusData;
    const syncStatusLabel = syncEntityStatuses.find((item) => item.value === syncStatus).label;
    const cname = cn("badge mr-1", {
        "badge-success": syncStatus === syncEntityStatusesEnum.Success,
        "badge-danger": syncStatus === syncEntityStatusesEnum.Failed,
    });
    const truncateProps = {
        ClosedWrapper: (props) => (
            <Tooltip overlay={comment} overlayClassName="show-bid__main-info--tooltip" mouseEnterDelay={1}>
                <em className="show-bid__main-info--pre-line">{props.children}</em>
            </Tooltip>
        ),

        OpenedWrapper: (props) => <em className="show-bid__main-info--pre-line">{props.children}</em>,
        text: comment,
        ...truncateStringConfig,
    };
    const { utcOffset } = organizationTimezone;
    if (!organizationTimezone.id) {
        return null;
    }
    const localeFixedAt = new Date(fixedAt).toLocaleString("ru-RU", { timeZone: organizationTimezone.id });
    const offsetArr = (utcOffset.charAt(0) === "-" ? utcOffset : `+${utcOffset}`).split(":");
    const offset = `${offsetArr[0]}:${offsetArr[1]}`;

    return (
        <>
            <div className="show-bid__main-info--title">Синхронизация с 1С</div>
            <div className="show-bid__main-info--value" data-test-id="bid-sync-status">
                <span className={cname}>{syncStatusLabel}</span>
                {localeFixedAt} ({offset})
            </div>
            {comment && (
                <div className="show-bid__main-info--row show-bid__main-info--without-gap text-muted">
                    <TruncatedString {...truncateProps} />
                </div>
            )}
        </>
    );
};

export default BitSyncStatusInfo;
